/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_No_OrdersInputs */

const vi_customer_no_orders = /** @type {(inputs: Customer_No_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có đơn hàng`)
};

/**

* @param {Customer_No_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_no_orders = /** @type {((inputs?: Customer_No_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_No_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_no_orders(inputs)
});